import {EventApiModel} from "../models/event-api-model";
import {BaseFactory} from "../../../../infrastructure/factories/base-factory";
import {EventViewModel} from "../models/event-view-model";
import {MemberDomainModel} from "../../../yard/member/member-domain-model";
import {GameCompetitorDomainModel} from "../../../partial-game/models/game-competitor/game-competitor-domain-model";
import {EventDomainModel} from "../models/event-domain-model";
import {EventTypeDomainModel} from "../models/event-type-domain-model";
import {
  LineupsMemberDomainModel
} from "../../../yard/lineups/lineups-member/lineups-member-domain-model";
import {contractsUtils} from "../../../../infrastructure/utils/contracts-utils";
import {SportDomainModel} from "../../../sports/models/sport-domain-model";

export class EventFactory extends BaseFactory {
  static injectables = [...BaseFactory.injectables];

  createDomainModel(apiModel: EventApiModel, members: Array<MemberDomainModel>, homeCompetitor: GameCompetitorDomainModel, awayCompetitor: GameCompetitorDomainModel, sport: SportDomainModel): EventDomainModel {
    let memberDomain: MemberDomainModel = new MemberDomainModel({}, false, sport);

    if (!apiModel) {
      return null;
    }

    try {
      memberDomain = this.createMember(apiModel, members, homeCompetitor, awayCompetitor, sport);
    } catch (e) {
      this.logger.error(e, this.constructor.name)
    }

    let extraPlayers: Array<MemberDomainModel> = [];
    try {
      extraPlayers = this.createExtraPlayers(apiModel, members, homeCompetitor, awayCompetitor);
    } catch (e) {
      this.logger.error(e, this.constructor.name)
    }

    const eventType: EventTypeDomainModel = new EventTypeDomainModel(apiModel.eventType);

    const domain: EventDomainModel = new EventDomainModel(apiModel, memberDomain, extraPlayers, eventType);

    return domain;
  }

  createExtraPlayers(apiModel: EventApiModel, members: Array<MemberDomainModel>, homeCompetitor: GameCompetitorDomainModel, awayCompetitor: GameCompetitorDomainModel): Array<MemberDomainModel> {
    const extraPlayers: Array<MemberDomainModel> = apiModel?.extraPlayers.map((playerId: Number) => {
      const extraPlayer: MemberDomainModel = this.extractMember(playerId, members);
      const extraIsNational: Boolean = this.extractIsNational(homeCompetitor, awayCompetitor, extraPlayer);
      extraPlayer.isNational = extraIsNational;

      return extraPlayer;
    });

    return extraPlayers;
  }

  createMember(apiModel: EventApiModel, members: Array<MemberDomainModel>, homeCompetitor: GameCompetitorDomainModel, awayCompetitor: GameCompetitorDomainModel, sport: SportDomainModel): MemberDomainModel {
    const player: MemberDomainModel = this.extractMember(apiModel.playerId, members);
    contractsUtils.required(player, 'Player id: ' + apiModel.playerId + ' was not found in api response');

    const isNational: Boolean = this.extractIsNational(homeCompetitor, awayCompetitor, player);
    const memberDomain: MemberDomainModel = new MemberDomainModel(player, isNational, sport);

    return memberDomain;
  }

  createVM(domain: EventDomainModel):
    EventViewModel {
    const vm: EventViewModel = new EventViewModel(domain);

    return vm;
  }

  extractMember(playerId: Number, members: Array<MemberDomainModel>): LineupsMemberDomainModel {
    const player: MemberDomainModel = members.find((member: MemberDomainModel) => member.id === playerId);

    return player
  }

  extractIsNational(homeCompetitor: GameCompetitorDomainModel, awayCompetitor: GameCompetitorDomainModel, member: MemberDomainModel): Boolean {
    const existingInHomeCompetitor: boolean = member.competitorId === homeCompetitor.id;
    const isNational = existingInHomeCompetitor ? homeCompetitor.isNational : awayCompetitor.isNational;

    return isNational;
  }
}
